import { VcsMessagingControllerService } from 'api';
import type { WebinarModeData } from 'api/types';
import { getRoomNameAndWorkspaceId } from 'useCase/moderation/utils/moderatorApi';
import { createLogger } from '@web-chat-core/toolkit';

const logger = createLogger({ prefix: 'Webinar' });

export type ChangeWebinarModeParams = {
    webinarMode: WebinarModeData;
    jwtToken: string | null;
};

/**
 * Вызывает changeWebinarModeOAuth (meet всегда использует OAuth endpoints).
 */
export const changeWebinarModeApi = async ({ webinarMode, jwtToken }: ChangeWebinarModeParams): Promise<boolean> => {
    const { roomName } = getRoomNameAndWorkspaceId();
    if (!roomName) {
        logger.warn('changeWebinarModeApi: нет roomName');
        return false;
    }

    try {
        const { error } = await VcsMessagingControllerService.changeWebinarModeOAuth({
            roomName,
            webinarMode,
            jwtToken: jwtToken ?? undefined,
        });
        return !error;
    } catch (err) {
        logger.error('changeWebinarModeApi error', err);
        return false;
    }
};
